import { __decorate, __param } from 'tslib';
import { forwardRef, Optional, Self, Inject, ChangeDetectorRef, ViewChild, Input, ContentChild, TemplateRef, Component, ChangeDetectionStrategy, Directive, NgModule } from '@angular/core';
import { NgControl } from '@angular/forms';
import { TUI_FOCUSABLE_ITEM_ACCESSOR, AbstractTuiControl, isNativeFocused, setNativeFocused, tuiDefaultProp, TuiActiveZoneModule } from '@taiga-ui/cdk';
import { TUI_DATA_LIST_HOST, TuiHostedDropdownComponent, TuiPrimitiveTextfieldComponent, TuiDataListDirective, TuiAbstractTextfieldHost, TUI_TEXTFIELD_HOST, TuiPrimitiveTextfieldModule, TuiHostedDropdownModule, TuiTextfieldComponent } from '@taiga-ui/core';
import { TUI_VALUE_ACCESSOR_PROVIDER, FIXED_DROPDOWN_CONTROLLER_PROVIDER } from '@taiga-ui/kit/providers';
import { CommonModule } from '@angular/common';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@taiga-ui/core';
import * as ɵngcc2 from '@taiga-ui/cdk';
import * as ɵngcc3 from '@angular/forms';

const _c0 = ["*", [["input"]]];
const _c1 = ["*", "input"];
const TUI_INPUT_PROVIDERS = [
    TUI_VALUE_ACCESSOR_PROVIDER,
    FIXED_DROPDOWN_CONTROLLER_PROVIDER,
    {
        provide: TUI_FOCUSABLE_ITEM_ACCESSOR,
        useExisting: forwardRef(() => TuiInputComponent),
    },
    {
        provide: AbstractTuiControl,
        useExisting: forwardRef(() => TuiInputComponent),
    },
    {
        provide: TUI_DATA_LIST_HOST,
        useExisting: forwardRef(() => TuiInputComponent),
    },
];

let TuiInputComponent = class TuiInputComponent extends AbstractTuiControl {
    constructor(control, changeDetectorRef) {
        super(control, changeDetectorRef);
        this.icon = null;
        this.iconAlign = 'left';
        this.datalist = '';
        this.open = false;
    }
    get nativeFocusableElement() {
        return this.computedDisabled || !this.textfield
            ? null
            : this.textfield.nativeFocusableElement;
    }
    get focused() {
        return (isNativeFocused(this.nativeFocusableElement) ||
            (!!this.hostedDropdown && this.hostedDropdown.focused));
    }
    get canOpen() {
        return this.interactive && !!this.datalist;
    }
    onValueChange(value) {
        this.updateValue(value);
        this.open = true;
    }
    onHovered(hovered) {
        this.updateHovered(hovered);
    }
    onActiveZone(active) {
        this.updateFocused(active);
    }
    handleOption(item) {
        this.setNativeValue(String(item));
        this.focusInput();
        this.updateValue(String(item));
        this.open = false;
    }
    getFallbackValue() {
        return '';
    }
    focusInput(preventScroll = false) {
        if (this.nativeFocusableElement) {
            setNativeFocused(this.nativeFocusableElement, true, preventScroll);
        }
    }
    setNativeValue(value) {
        if (this.nativeFocusableElement) {
            this.nativeFocusableElement.value = value;
        }
    }
};
TuiInputComponent.ɵfac = function TuiInputComponent_Factory(t) { return new (t || TuiInputComponent)(ɵngcc0.ɵɵdirectiveInject(NgControl, 10), ɵngcc0.ɵɵdirectiveInject(ChangeDetectorRef)); };
TuiInputComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TuiInputComponent, selectors: [["tui-input"]], contentQueries: function TuiInputComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TuiDataListDirective, 5, TemplateRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.datalist = _t.first);
    } }, viewQuery: function TuiInputComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(TuiHostedDropdownComponent, 5);
        ɵngcc0.ɵɵviewQuery(TuiPrimitiveTextfieldComponent, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.hostedDropdown = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.textfield = _t.first);
    } }, inputs: { icon: "icon", iconAlign: "iconAlign" }, features: [ɵngcc0.ɵɵProvidersFeature(TUI_INPUT_PROVIDERS), ɵngcc0.ɵɵInheritDefinitionFeature], ngContentSelectors: _c1, decls: 4, vars: 13, consts: [[1, "hosted", 3, "canOpen", "content", "open", "openChange", "tuiActiveZoneChange"], ["automation-id", "tui-input__textfield", 1, "textfield", 3, "pseudoFocused", "pseudoHovered", "invalid", "nativeId", "readOnly", "iconContent", "iconAlign", "disabled", "focusable", "value", "valueChange", "hoveredChange"]], template: function TuiInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c0);
        ɵngcc0.ɵɵelementStart(0, "tui-hosted-dropdown", 0);
        ɵngcc0.ɵɵlistener("openChange", function TuiInputComponent_Template_tui_hosted_dropdown_openChange_0_listener($event) { return ctx.open = $event; })("tuiActiveZoneChange", function TuiInputComponent_Template_tui_hosted_dropdown_tuiActiveZoneChange_0_listener($event) { return ctx.onActiveZone($event); });
        ɵngcc0.ɵɵelementStart(1, "tui-primitive-textfield", 1);
        ɵngcc0.ɵɵlistener("valueChange", function TuiInputComponent_Template_tui_primitive_textfield_valueChange_1_listener($event) { return ctx.onValueChange($event); })("hoveredChange", function TuiInputComponent_Template_tui_primitive_textfield_hoveredChange_1_listener($event) { return ctx.onHovered($event); });
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵprojection(3, 1, ["ngProjectAs", "input", 5, ["input"]]);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("canOpen", ctx.canOpen)("content", ctx.datalist || "")("open", ctx.open);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("pseudoFocused", ctx.computedFocused)("pseudoHovered", ctx.computedHovered)("invalid", ctx.computedInvalid)("nativeId", ctx.nativeId)("readOnly", ctx.readOnly)("iconContent", ctx.icon)("iconAlign", ctx.iconAlign)("disabled", ctx.computedDisabled)("focusable", ctx.computedFocusable)("value", ctx.value);
    } }, directives: [ɵngcc1.TuiHostedDropdownComponent, ɵngcc2.TuiActiveZoneDirective, ɵngcc1.TuiPrimitiveTextfieldComponent, ɵngcc1.TuiPrimitiveTextfieldDirective], styles: ["[_nghost-%COMP%]{display:block;border-radius:var(--tui-radius-m);text-align:left}._disabled[_nghost-%COMP%]{pointer-events:none}.hosted[_ngcontent-%COMP%]{display:block;border-radius:inherit}.textfield[_ngcontent-%COMP%]{border-radius:inherit;text-align:inherit}"], changeDetection: 0 });
TuiInputComponent.ctorParameters = () => [
    { type: NgControl, decorators: [{ type: Optional }, { type: Self }, { type: Inject, args: [NgControl,] }] },
    { type: ChangeDetectorRef, decorators: [{ type: Inject, args: [ChangeDetectorRef,] }] }
];
__decorate([
    ViewChild(TuiHostedDropdownComponent)
], TuiInputComponent.prototype, "hostedDropdown", void 0);
__decorate([
    ViewChild(TuiPrimitiveTextfieldComponent)
], TuiInputComponent.prototype, "textfield", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputComponent.prototype, "icon", void 0);
__decorate([
    Input(),
    tuiDefaultProp()
], TuiInputComponent.prototype, "iconAlign", void 0);
__decorate([
    ContentChild(TuiDataListDirective, { read: TemplateRef })
], TuiInputComponent.prototype, "datalist", void 0);
TuiInputComponent = __decorate([ __param(0, Optional()),
    __param(0, Self()),
    __param(0, Inject(NgControl)),
    __param(1, Inject(ChangeDetectorRef))
], TuiInputComponent);

var TuiInputDirective_1;
let TuiInputDirective = TuiInputDirective_1 = class TuiInputDirective extends TuiAbstractTextfieldHost {
    onValueChange(value) {
        this.host.onValueChange(value);
    }
};
TuiInputDirective.ɵfac = /*@__PURE__*/ function () { let ɵTuiInputDirective_BaseFactory; return function TuiInputDirective_Factory(t) { return (ɵTuiInputDirective_BaseFactory || (ɵTuiInputDirective_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TuiInputDirective)))(t || TuiInputDirective); }; }();
TuiInputDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: TuiInputDirective, selectors: [["tui-input"]], features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: TUI_TEXTFIELD_HOST,
                useExisting: forwardRef(() => TuiInputDirective_1)
            },
        ]), ɵngcc0.ɵɵInheritDefinitionFeature] });

let TuiInputModule = class TuiInputModule {
};
TuiInputModule.ɵfac = function TuiInputModule_Factory(t) { return new (t || TuiInputModule)(); };
TuiInputModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: TuiInputModule });
TuiInputModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            TuiActiveZoneModule,
            TuiPrimitiveTextfieldModule,
            TuiHostedDropdownModule,
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiInputComponent, [{
        type: Component,
        args: [{
                selector: 'tui-input',
                template: "<tui-hosted-dropdown\n    class=\"hosted\"\n    [canOpen]=\"canOpen\"\n    [content]=\"datalist || ''\"\n    [(open)]=\"open\"\n    (tuiActiveZoneChange)=\"onActiveZone($event)\"\n>\n    <tui-primitive-textfield\n        automation-id=\"tui-input__textfield\"\n        class=\"textfield\"\n        [pseudoFocused]=\"computedFocused\"\n        [pseudoHovered]=\"computedHovered\"\n        [invalid]=\"computedInvalid\"\n        [nativeId]=\"nativeId\"\n        [readOnly]=\"readOnly\"\n        [iconContent]=\"icon\"\n        [iconAlign]=\"iconAlign\"\n        [disabled]=\"computedDisabled\"\n        [focusable]=\"computedFocusable\"\n        [value]=\"value\"\n        (valueChange)=\"onValueChange($event)\"\n        (hoveredChange)=\"onHovered($event)\"\n    >\n        <ng-content></ng-content>\n        <ng-content\n            select=\"input\"\n            ngProjectAs=\"input\"\n        ></ng-content>\n    </tui-primitive-textfield>\n</tui-hosted-dropdown>\n",
                changeDetection: ChangeDetectionStrategy.OnPush,
                providers: TUI_INPUT_PROVIDERS,
                styles: [":host{display:block;border-radius:var(--tui-radius-m);text-align:left}:host._disabled{pointer-events:none}.hosted{display:block;border-radius:inherit}.textfield{border-radius:inherit;text-align:inherit}"]
            }]
    }], function () { return [{ type: ɵngcc3.NgControl, decorators: [{
                type: Optional
            }, {
                type: Self
            }, {
                type: Inject,
                args: [NgControl]
            }] }, { type: ɵngcc0.ChangeDetectorRef, decorators: [{
                type: Inject,
                args: [ChangeDetectorRef]
            }] }]; }, { icon: [{
            type: Input
        }], iconAlign: [{
            type: Input
        }], datalist: [{
            type: ContentChild,
            args: [TuiDataListDirective, { read: TemplateRef }]
        }], hostedDropdown: [{
            type: ViewChild,
            args: [TuiHostedDropdownComponent]
        }], textfield: [{
            type: ViewChild,
            args: [TuiPrimitiveTextfieldComponent]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiInputDirective, [{
        type: Directive,
        args: [{
                selector: 'tui-input',
                providers: [
                    {
                        provide: TUI_TEXTFIELD_HOST,
                        useExisting: forwardRef(() => TuiInputDirective_1)
                    },
                ]
            }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TuiInputModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    TuiActiveZoneModule,
                    TuiPrimitiveTextfieldModule,
                    TuiHostedDropdownModule,
                ],
                declarations: [TuiInputComponent, TuiInputDirective],
                exports: [TuiInputComponent, TuiInputDirective, TuiTextfieldComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiInputModule, { declarations: function () { return [TuiInputComponent, TuiInputDirective]; }, imports: function () { return [CommonModule,
        TuiActiveZoneModule,
        TuiPrimitiveTextfieldModule,
        TuiHostedDropdownModule]; }, exports: function () { return [TuiInputComponent, TuiInputDirective, TuiTextfieldComponent]; } }); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TUI_INPUT_PROVIDERS, TuiInputComponent, TuiInputDirective, TuiInputModule };

